import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Area } from 'src/app/interfaces/area';
import { AreaService } from 'src/app/services/area.service';
import { ErrorService } from 'src/app/services/error.service';

@Component({
  selector: 'app-area',
  templateUrl: './area.component.html',
  styleUrls: ['./area.component.css']
})
export class AreaComponent implements OnInit {
  listAreas: Area[] = [];
  loading = false;

  constructor(
    private _areaService: AreaService,
    private toastr: ToastrService,
    private _errorService: ErrorService
  ) {}

  ngOnInit(): void {
    this.getListAreas();
  }

  getListAreas() {
    this.loading = true;

    this._areaService.getListAreas().subscribe({
      next: (data: Area[]) => {
        this.listAreas = data;
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al obtener la lista de areas:', error);
        this._errorService.msjError(error);
        this.loading = false;
      }
    });
  }

  deleteArea(id: number) {
    this.loading = true;
    this._areaService.deleteArea(id).subscribe({
      next: () => {
        this.getListAreas();
        this.toastr.warning('El area fue eliminada con exito', 'Area eliminada');
      },
      error: (error) => {
        console.error('Error al eliminar el area:', error);
        this._errorService.msjError(error);
        this.loading = false;
      }
    });
  }
}
